<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col class="d-flex flex-wrap mb-4" cols="12">
          <div>
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 4 : 8"
                class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
                height="60"
                width="60"
                :class="{ selected: selectedDesign === '' }"
                @click="chooseDesign('')"
              >
                <v-icon color="#222" size="32">mdi-cancel</v-icon>
              </v-card>
            </v-hover>
          </div>
          <div v-for="(item, index) in designObject" :key="index">
            <v-hover v-slot="{ hover }">
              <v-card
                :elevation="hover ? 4 : 8"
                class="ma-2 pa-3 rounded-lg d-flex align-center justify-center pattern"
                height="60"
                width="60"
                :class="{ selected: selectedDesign === item.value }"
                @click="chooseDesign(item.value)"
              >
                <img
                  :alt="item.value"
                  :src="item.img"
                  class="rounded-0"
                  :class="{ filterwhite: selectedDesign === item.value }"
                />
              </v-card>
            </v-hover>
          </div>
        </v-col>

        <v-col class="d-flex align-center grey--text" cols="12">
          {{ $t("qrCodeSquare.dots_color") }}
          <v-divider class="mx-2" />
        </v-col>

        <v-col cols="12" md="6">
          <v-switch
            v-model="bgSwitch"
            :label="$t('qrCodeSquare.gradient_color')"
          />
        </v-col>

        <template v-if="bgSwitch">
          <v-col class="pa-2" cols="12" md="6">
            <v-radio-group
              v-model="options.cornersSquareOptions.gradient.type"
              class="ma-0"
              row
              @change="$emit('update', true)"
            >
              <v-radio :label="$t('qrCodeSquare.linear')" value="linear" />
              <v-radio :label="$t('qrCodeSquare.radial')" value="radial" />
            </v-radio-group>
          </v-col>

          <v-col class="pa-2" cols="12">
            <v-slider
              v-model="computedRotation"
              append-icon="mdi-rotate-360"
              :label="$t('qrCodeSquare.color_rotation')"
              max="360"
              min="0"
              thumb-label
              track-color="grey"
              @input="$emit('update', true)"
            >
              <template v-slot:thumb-label="{ value }">
                <div
                  class="d-flex align-center justify-center"
                  style="
                    width: 20px;
                    height: 20px;
                    background-color: rgba(12, 15, 26, 0.7);
                    border-radius: 50%;
                  "
                >
                  {{ value }}°
                </div>
              </template>
            </v-slider>
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <color-picker
              v-model="
                options.cornersSquareOptions.gradient.colorStops[0].color
              "
              :label="$t('qrCodeSquare.first_color')"
              @input="$emit('update', true)"
            />
          </v-col>

          <v-col class="pa-2" cols="12" md="6">
            <color-picker
              v-model="
                options.cornersSquareOptions.gradient.colorStops[1].color
              "
              :label="$t('qrCodeSquare.second_color')"
              @input="$emit('update', true)"
            />
          </v-col>
        </template>

        <v-col v-else class="pa-2" cols="12" md="6">
          <color-picker
            v-model="options.cornersSquareOptions.color"
            :label="$t('qrCodeSquare.dots_color_label')"
            @input="
              options.cornersSquareOptions.gradient = null;
              $emit('update', true);
            "
          />
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPicker from "../../components/colorPicker";

export default {
  name: "qrCodeSquare",

  components: { ColorPicker },

  props: {
    value: Object,
    color: Array,
  },

  data: () => ({
    selectedDesign: null,
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeSquare",
    bgSwitch: false,
designObject: [
  { value: "vortex2", img: "/media/markOut/vertex2.svg" },
  { value: "default", img: "/media/markOut/default.svg" },
  { value: "flurry", img: "/media/markOut/flurry.svg" },
  { value: "sdoz", img: "/media/markOut/sdoz.svg" },
  { value: "drop_in", img: "/media/markOut/drop_in.svg" },
  { value: "drop", img: "/media/markOut/drop.svg" },
  { value: "dropeye", img: "/media/markOut/dropeye.svg" },
  { value: "dropeyeleft", img: "/media/markOut/dropeyeleft.svg" },
  { value: "dropeyeleaf", img: "/media/markOut/dropeyeleaf.svg" },
  { value: "dropeyeright", img: "/media/markOut/dropeyeright.svg" },
  { value: "squarecircle", img: "/media/markOut/squarecircle.svg" },
  { value: "circle", img: "/media/markOut/circle.svg" },
  { value: "rounded", img: "/media/markOut/rounded.svg" },
  { value: "flower", img: "/media/markOut/flower.svg" },
  { value: "flower_in", img: "/media/markOut/flower_in.svg" },
  { value: "leaf", img: "/media/markOut/leaf.svg" },
  { value: "3-corners", img: "/media/markOut/3-corners.svg" },
  { value: "dots", img: "/media/markOut/dots.svg" },
  { value: "bruised", img: "/media/markOut/bruised.svg" },
    { value: "9-dots-fat", img: "/media/markOut/9-dots-fat.svg" },
  { value: "elastic", img: "/media/markOut/elastic.svg" },
  { value: "sun", img: "/media/markOut/sun.svg" },
  { value: "star", img: "/media/markOut/star.svg" },
  { value: "diamond", img: "/media/markOut/diamond.svg" },
  { value: "danger", img: "/media/markOut/danger.svg" },
  { value: "cross", img: "/media/markOut/cross.svg" },
  { value: "plus", img: "/media/markOut/plus.svg" },
  { value: "x", img: "/media/markOut/x.svg" },
  { value: "heart", img: "/media/markOut/heart.svg" },
  { value: "shake", img: "/media/markOut/shake.svg" },
  { value: "blob", img: "/media/markOut/blob.svg" },
  { value: "special-circle-vert", img: "/media/markOut/special-circle-vert.svg" },
  { value: "special-circle", img: "/media/markOut/special-circle.svg" },
  { value: "special-diamond", img: "/media/markOut/special-diamond.svg" },
  { value: "ellipse", img: "/media/markOut/ellipse.svg" },
  { value: "diagonal", img: "/media/markOut/diagonal.svg" },
  { value: "classy", img: "/media/markOut/classy.svg" },
],

    rotation: 0,
    tempColor1: "#001554",
    tempColor2: "#001554",
  }),

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedRotation: {
      get() {
        return this.rotation;
      },
      set(val) {
        this.rotation = val;
        if (this.options.cornersSquareOptions.gradient) {
          this.options.cornersSquareOptions.gradient.rotation =
            (val * Math.PI) / 180;
        }
        this.$emit("update", true);
      },
    },
  },

  watch: {
    bgSwitch(val) {
      if (!val) {
        this.options.cornersSquareOptions.gradient = null;
        this.options.cornersSquareOptions.color = "#001554";
      } else {
        this.options.cornersSquareOptions.gradient = this.options
          .cornersSquareOptions.gradient || {
          type: "linear",
          rotation: 0,
          colorStops: [
            {
              offset: 0,
              color:
                this.tempColor1 ||
                this.options.cornersSquareOptions.color ||
                "#001554",
            },
            {
              offset: 1,
              color:
                this.tempColor2 ||
                this.options.cornersSquareOptions.color ||
                "#001554",
            },
          ],
        };
      }
      this.$emit("update", true);
    },
    // "options.cornersSquareOptions.gradient.colorStops": {
    //   handler(newValue) {
    //     if (newValue && newValue.length >= 2) {
    //       this.tempColor1 = newValue[0].color;
    //       this.tempColor2 = newValue[1].color;
    //     }
    //   },
    //   deep: true,
    // },
  },

  methods: {
    chooseDesign(value) {
      this.selectedDesign = value;
      this.options.cornersSquareOptions.type = value;
      this.$emit("update");
    },
    // updateColor(index, value) {
    //   if (this.options.cornersSquareOptions.gradient) {
    //     this.options.cornersSquareOptions.gradient.colorStops[index].color =
    //       value;
    //     if (index === 0) this.tempColor1 = value;
    //     else this.tempColor2 = value;
    //     this.$emit("update", true);
    //   }
    // },
  },
};
</script>

<style scoped>
.color-picker-preview {
  background-color: v-bind("tempColor1");
}
</style>
